/** A customer's own page gives each tab its own route, `/customers/:id/<tab>` (`recordTabRoutes`). */
export const CUSTOMER_TABS = ['details', 'history'] as const;
export type CustomerTab = (typeof CUSTOMER_TABS)[number];

export const CUSTOMER_TAB_LABELS: Record<CustomerTab, string> = { details: 'Details', history: 'History' };

export function customerPath(id: string): string {
  return `/customers/${id}`;
}

export function customerTabPath(id: string, tab: CustomerTab): string {
  return `${customerPath(id)}/${tab}`;
}
